import { matchPath, parsePath } from 'react-router-dom';
import { ROUTE_PRODUCT_MAPPING } from '@/constants';

/**
 * Resolves the native application a URL path belongs to, or `undefined` on
 * platform pages. Matching is delegated to react-router, so `end: false` gives
 * whole-segment prefix matching and `/knowledge-library-archive` is not the
 * Knowledge Library app.
 */
export function getAppCodeForPath(pathname?: string): string | undefined {
  if (!pathname) {
    return undefined;
  }

  const { pathname: pathOnly } = parsePath(pathname);

  if (!pathOnly) {
    return undefined;
  }

  const match = Object.entries(ROUTE_PRODUCT_MAPPING).find(([route]) =>
    matchPath({ path: route, end: false }, pathOnly)
  );

  return match?.[1];
}
